<template>
  <div class="form-view organization-modal">
    <h1 class="text-center">Vælg forsyning</h1>
    <div class="login-container">
        <select v-model="selectedOrganization" @change="selectOrganization($event)" class="flexbox-center custom-login-select">
            <option disabled="disabled" value="">Vælg forsyning</option>
            <option v-for="organization in data" :key="organization.id" :value="organization.id" :selected="organization.id">
                {{organization.name}}
            </option>
        </select>
        <div class="text-center buttons-modal">
            <a @click="chooseOrganization()">Vælg</a>
            <a @click="closeModal">Fortryd</a>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'login-modal-organization',
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            selectedOrganization: null
        }
    },
    methods: {
        ...mapActions({
            changeOrganizationContext: 'changeOrganizationContext',
            setSelectedOrganizationId: 'setSelectedOrganizationId',
            getCurrentUserInfo: 'getCurrentUserInfo'
        }),
        closeModal () {
            this.$emit('close')
        },
        selectOrganization ($event) {
            this.selectedOrganization = this.data[$event.target.selectedIndex - 1].id
            this.setSelectedOrganizationId(this.selectedOrganization)
        },
        chooseOrganization () {
            let _self = this
            if (_self.selectedOrganization) {
                new Promise((resolve, reject) => {
                    _self.changeOrganizationContext(_self.selectedOrganization).then(response => {
                        _self.claims = { claims: response.data }
                        _self.setSelectedOrganizationId(_self.selectedOrganization).then(response => {
                            _self.getCurrentUserInfo(_self.claims).then(response => {
                                _self.$router.push({ name: 'administration' })
                                resolve(response)
                            })
                        })
                    })
                }).catch((error) => {
                    console.error('Fejl i valg af organisation', error)
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/login/login-modal-organization.vue